import React, {useEffect, useRef, useState} from 'react'
import Tikia from './Tikia';
import TaskEditor from '../planner/TaskEditor';
import TaskTagger from '../planner/TaskTagger';
import PopingTask from './PopingTask';
import useQueueHandler from '../../hooks/useQueueHandler';
import useWebSocketCaller from '../../hooks/useWebSocketCaller';
import { useWebSocketContext } from '../../providers/WebSocketContextProvider';
import { useOperatorContext } from '../login/OperatorContextProvider';
import './DoIt.css'

export default function DoIt() {

  const [allTasks, setAllTasks]         = useState([]);
  const [visibleTasks, setVisibleTasks] = useState([]);
  const [tags, setTags]                 = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [popTaskData, setPopTaskData]   = useState(null);
  const tagsRef = useRef([]);

  const {isWebSocketReady, webSocketState} = useWebSocketContext();
  const {operator} = useOperatorContext();

  //
  // ---[  Get Team Tasks ]   [  useWebSocketComm  ]---
  //
  //const {myData:tasksList, onMyCleanup, onMyMount} = useWebSocketComm('get-team-tasks', null, 'my-team-tasks', null, true, requestor);
  const {sendMessage} = useWebSocketCaller() // get-team-tasks
  const {queueData:tasksList} = useQueueHandler('my-team-tasks');

  useEffect(()=>{
    if (isWebSocketReady()) {
      console.log('[DoIt] Effect get-team-tasks');      
      sendMessage('get-team-tasks', {
        teamId: operator.selectedTeamId,
        username: operator.username,
        accountId: operator.accountId,
        filterTags: []
      })
    }
  }, [operator?.selectedTeamId, operator?.username, operator?.accountId, isWebSocketReady, sendMessage, webSocketState]);
  

  //
  // ---[  EFFECT  ]---  [tasksList]
  //
  // tasksList --> triggers [allTasks]
  useEffect(()=>{
    if (tasksList) {
      setAllTasks([...tasksList]);
    }
  }, [tasksList]);

  // 
  // ---[  EFFECT  ]---  [allTasks]
  //
  useEffect(()=>{
    if (allTasks) {      
      console.debug('[Doit Effect] [allTasks] [total: %s] applying filters...', allTasks.length);
      setTags(extractTags(allTasks).slice(0,26));
      // TODO: Remember Selected Tags
      setSelectedTags(tagsRef.current);
      setVisibleTasks(allTasks);
    }
  },[allTasks]);

  //
  // ---[  EFFECT  ]---  [selectedTags]
  //
  useEffect(()=> {
    if (selectedTags) {
      tagsRef.current = [...selectedTags];
      console.group('FILTER TAGS: '+selectedTags); console.groupEnd();
      const filtered = allTasks.filter(task => hasAll(task, selectedTags));
      setVisibleTasks(filtered);
    }
  }, [selectedTags,allTasks]);
    
  // ---[  Extract Tags  ]---
  //
  const extractTags = (tasksArr) => {
    const tagsSet = new Set();
    const capSet = new Set();
    tasksArr.forEach(task => {
      task.tags?.forEach(tag =>  {
        const cap = tag.toUpperCase();
        if (!capSet.has(cap)) {
          capSet.add(cap);
          tagsSet.add(tag);
        }
      });      
    });

    return Array.from(tagsSet);
  }


  //
  // ---[  onTaskCreated  ]---
  //
  const onTaskCreated = (createdTaskData) => {
    console.debug('onTaskCreated: %s', JSON.stringify(createdTaskData));
    setAllTasks(prev => [...prev, createdTaskData]);
  }

  //
  // ---[  onTaskUpdated  ]---
  //
  const onTaskUpdated = (updatedTask) => {
    console.debug('[DoIt onTaskUpdated] updatedTask: %s', JSON.stringify(updatedTask));
    setAllTasks(prevArr => {
      const withoutOriginal = prevArr.filter(task => task.taskId !== updatedTask.taskId);
      const withUpdated     = [...withoutOriginal, updatedTask];  
      return withUpdated;
    });
  }

  //
  // ---[  onPopTask  ]---
  //
  const onPopTask = (popTaskInfo) => {
    setPopTaskData(popTaskInfo);
  }

  // --- Render ---

  const hasAll  = (task, givenTags) =>  {    
    const result = task.tags ? givenTags.filter(givenTag => task.tags.includes(givenTag)).length === givenTags.length : false;
    return result;
  }

  const tikiName  = selectedTags ? selectedTags.map(tag => `${tag} + `) : 'Unfiltered';

  return (
    <div className='doit'>
      <div className='doitHeader'>
        Do It Now!
      </div>
      <div className='goalDesigner'>
        <div className='goalsHeader'>
          Goals Header
        </div>
        <div className='goalsWork'>
          
        </div>
        <div className='goalsFooter'>
          Goals Footer
        </div>
      </div>
      
      <div className='doitWork'>
        <Tikia tikiName={tikiName} tasks={visibleTasks} whenTaskUpdated={onTaskUpdated}/>
      </div>

      <TaskTagger tags={tags} selectTags={setSelectedTags}/>

      <div className='doitFooter'>
        <PopingTask popTaskData={popTaskData} onTaskCreated={onTaskCreated}/>
        <TaskEditor onPopTask={onPopTask}/>
      </div>
    </div>
  )
}
